var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpecialCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70%",
    height: "auto",
    viewBox: "0 0 296.176 262.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digitalization_mobile_2_",
    "data-name": "Digitalization_mobile (2)",
    transform: "translate(-98.527 -48.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228",
    transform: "translate(335.971 84.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17861",
    "data-name": "Path 17861",
    d: "M370.4,92.822h2.188V91.181a1.1,1.1,0,0,1,1.1-1.094h8.755a1.094,1.094,0,0,1,1.094,1.094v1.641h2.189V91.181a3.288,3.288,0,0,0-3.284-3.284h-8.755a3.287,3.287,0,0,0-3.284,3.284v1.641Z",
    transform: "translate(-362.743 -87.897)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17862",
    "data-name": "Path 17862",
    d: "M391.76,100.637l.788.032v-1.6a3.286,3.286,0,0,0-3.283-3.284H365.188a3.287,3.287,0,0,0-3.283,3.284v2.736h2.188V99.074a1.1,1.1,0,0,1,1.094-1.094h24.078a1.1,1.1,0,0,1,1.094,1.094v1.6a13.041,13.041,0,0,1,1.4-.033",
    transform: "translate(-361.904 -88.676)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17863",
    "data-name": "Path 17863",
    d: "M376.988,115.973c.559-.56,1.215-1.2,1.956-1.894H365.188a1.1,1.1,0,0,1-1.094-1.1v-9.3H361.9v9.3a3.288,3.288,0,0,0,3.284,3.284h11.538c.082-.1.168-.2.262-.295",
    transform: "translate(-361.904 -89.454)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17864",
    "data-name": "Path 17864",
    d: "M379.415,116.608a1.867,1.867,0,0,0-.6,1.3,1.655,1.655,0,0,0,.384,1.161,1.364,1.364,0,0,0,1.051.506,1.953,1.953,0,0,0,1.357-.678q.738-.763,4.432-4.226,3.863-3.633,3.991-3.758a3.388,3.388,0,0,1,1.478-.715c.761-.162,1.252-.273,1.472-.326a9.831,9.831,0,0,0,1.6-.557,3.93,3.93,0,0,0,1.274-.653,8.805,8.805,0,0,0,.639-1.1,6.329,6.329,0,0,0,.516-1.217.573.573,0,0,0-.167-.469l-.2-.164-2.371,1.152a.429.429,0,0,1-.349.073,5.274,5.274,0,0,1-.711-.459,2.279,2.279,0,0,1-.772-.869,1.739,1.739,0,0,1-.1-1.052q.069-.419,1.247-.942c.839-.334,1.331-.544,1.475-.624.059-.037.022-.145-.109-.323l-.22-.247-1.332-.054a7.727,7.727,0,0,0-2.155.171q-.719.224-1.249,1.55a6.282,6.282,0,0,0-.483,1.887,3.607,3.607,0,0,1-.513,1.438,4.874,4.874,0,0,1-1.052,1.358q-1.175,1-3.477,3.09-3.183,2.87-5.061,4.751",
    transform: "translate(-363.572 -89.324)",
    fill: "#007dc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9230",
    "data-name": "Group 9230",
    transform: "translate(105.071 108.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17865",
    "data-name": "Path 17865",
    d: "M124.21,116.392v-.982l1.871,2.1a.631.631,0,0,1,0,.829l-.068.076Z",
    transform: "translate(-107.556 -114.891)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17866",
    "data-name": "Path 17866",
    d: "M123.123,120.9l.037,0a.356.356,0,0,0,.319-.352v-5.352a.359.359,0,0,0-.357-.357.174.174,0,0,0-.037,0,.56.56,0,0,0-.381.189l-2.162,2.426a.633.633,0,0,0,0,.829l.069.078,2.159-2.424v4.609a.354.354,0,0,0,.316.352l.037,0",
    transform: "translate(-107.179 -114.834)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17867",
    "data-name": "Path 17867",
    d: "M117.349,120.8v.982l1.871-2.1a.629.629,0,0,0,0-.828l-.068-.078Z",
    transform: "translate(-106.879 -115.223)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17868",
    "data-name": "Path 17868",
    d: "M119.153,118.777l-1.8,2.024v.978l1.868-2.1a.627.627,0,0,0,0-.827Zm-1.8,3.009V120.8l1.8-2.025h0l.067.078a.629.629,0,0,1,0,.831Z",
    transform: "translate(-106.879 -115.223)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17869",
    "data-name": "Path 17869",
    d: "M116.224,115.96a.355.355,0,0,0-.316.354v4.608l-2.159-2.424-.069.078a.633.633,0,0,0,0,.829l2.162,2.426a.562.562,0,0,0,.381.191c-.007,0,.018,0,.037,0a.358.358,0,0,0,.357-.357v-5.351a.358.358,0,0,0-.319-.354.26.26,0,0,0-.037,0,.173.173,0,0,0-.037,0",
    transform: "translate(-106.502 -114.945)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17870",
    "data-name": "Path 17870",
    d: "M127.166,149.85H110.407v2.736l8.3,0h.124l8.336,0Z",
    transform: "translate(-106.194 -118.288)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17871",
    "data-name": "Path 17871",
    d: "M124.212,115.413v.978l1.8,2.023.067-.076a.627.627,0,0,0,0-.827Zm1.8,3h0l-1.8-2.024v-.986l0,0,1.869,2.1a.629.629,0,0,1,0,.831Z",
    transform: "translate(-107.556 -114.89)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17872",
    "data-name": "Path 17872",
    d: "M122.77,115.933v4.611a.351.351,0,0,0,.315.352l.037,0,.037,0a.357.357,0,0,0,.318-.352v-5.352a.355.355,0,0,0-.355-.355.237.237,0,0,0-.031,0h-.008a.571.571,0,0,0-.38.189l-2.161,2.426a.631.631,0,0,0,0,.828l.068.076Zm.352,4.968-.037,0a.355.355,0,0,1-.318-.354v-4.6l-2.157,2.421h0l-.068-.078a.633.633,0,0,1,0-.831l2.161-2.426a.572.572,0,0,1,.383-.189v0l0,0s.023,0,.036,0a.358.358,0,0,1,.358.358v5.352a.361.361,0,0,1-.321.354l-.038,0",
    transform: "translate(-107.178 -114.834)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17873",
    "data-name": "Path 17873",
    d: "M116.223,122.018h0l.036,0a.354.354,0,0,0,.355-.354v-5.352a.359.359,0,0,0-.318-.352.38.38,0,0,0-.074,0,.354.354,0,0,0-.315.352v4.61l0,0-2.157-2.423-.068.076a.629.629,0,0,0,0,.827l2.161,2.426a.578.578,0,0,0,.379.19m.039,0-.029,0h-.008a.566.566,0,0,1-.383-.191L113.68,119.4a.633.633,0,0,1,0-.831l.069-.078,0,0,2.156,2.421v-4.6a.357.357,0,0,1,.318-.355.38.38,0,0,1,.074,0,.362.362,0,0,1,.321.355v5.352a.359.359,0,0,1-.359.357",
    transform: "translate(-106.502 -114.945)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17874",
    "data-name": "Path 17874",
    d: "M108.471,124.992l-.423.046a2.618,2.618,0,0,0-2.313,2.55l0,.422h0v19.116h0l0,.422a2.62,2.62,0,0,0,2.313,2.55l.423.046Z",
    transform: "translate(-105.733 -115.836)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17875",
    "data-name": "Path 17875",
    d: "M130.6,150.143l.423-.046a2.62,2.62,0,0,0,2.313-2.55l0-.422h0V128.008l0,0,0-.422a2.622,2.622,0,0,0-2.313-2.551l-.423-.044Z",
    transform: "translate(-108.186 -115.836)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17876",
    "data-name": "Path 17876",
    d: "M127.166,125l-8.334,0h-.126l-8.3,0v2.736h16.759Z",
    transform: "translate(-106.194 -115.836)",
    fill: "#007dc5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231",
    transform: "translate(106.89 212.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17877",
    "data-name": "Path 17877",
    d: "M118.892,235.2l.581-.848.372,2.919a.659.659,0,0,1-.492.715l-.1.027Z",
    transform: "translate(-108.849 -230.786)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17878",
    "data-name": "Path 17878",
    d: "M119.472,234.353l-.579.844.359,2.811.1-.026a.655.655,0,0,0,.489-.713Zm-.223,3.659v0l-.359-2.814.583-.852,0,0,.37,2.918a.658.658,0,0,1-.492.717Z",
    transform: "translate(-108.849 -230.785)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17879",
    "data-name": "Path 17879",
    d: "M115.142,238.61a.33.33,0,0,0,.033.02.376.376,0,0,0,.485-.115l3.166-4.619a.374.374,0,0,0-.1-.518c-.016-.012-.039-.024-.033-.022a.592.592,0,0,0-.442-.06l-3.3.815a.663.663,0,0,0-.49.717l.014.105,3.3-.815-2.726,3.977a.372.372,0,0,0,.065.493l.032.023",
    transform: "translate(-108.412 -230.68)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17880",
    "data-name": "Path 17880",
    d: "M117.776,234.114l0,0-2.726,3.977a.367.367,0,0,0,.064.49.26.26,0,0,0,.031.024l.031.017,0,0a.377.377,0,0,0,.483-.116l3.166-4.619a.371.371,0,0,0-.1-.516l-.033-.02,0,0a.58.58,0,0,0-.44-.06l-3.3.815a.661.661,0,0,0-.489.715l.013.105Zm-2.424,4.562h0a.382.382,0,0,1-.178-.045l0,0-.031-.019-.031-.023a.371.371,0,0,1-.065-.495l2.724-3.974-3.294.815v0l-.014-.107a.662.662,0,0,1,.492-.717l3.3-.815a.616.616,0,0,1,.145-.019.6.6,0,0,1,.3.081h0c.013.009.024.014.033.02a.374.374,0,0,1,.155.24.369.369,0,0,1-.058.28l-3.167,4.619a.371.371,0,0,1-.309.163",
    transform: "translate(-108.412 -230.68)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17881",
    "data-name": "Path 17881",
    d: "M110.356,235.131l-.625.816,2.891-.553a.659.659,0,0,0,.528-.689l-.007-.107Z",
    transform: "translate(-107.945 -230.811)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17882",
    "data-name": "Path 17882",
    d: "M113.14,234.6l-2.783.533-.624.811,2.888-.553a.655.655,0,0,0,.526-.687Zm-3.413,1.348,0,0,.626-.816,2.788-.533v0l.007.105a.661.661,0,0,1-.529.69Z",
    transform: "translate(-107.945 -230.81)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17883",
    "data-name": "Path 17883",
    d: "M112.487,230.452a.372.372,0,0,0-.488.091l-2.934,3.826-.251-3.387-.105.02a.663.663,0,0,0-.528.689l.251,3.391a.6.6,0,0,0,.2.4.191.191,0,0,0,.031.024.373.373,0,0,0,.522-.068l3.407-4.445a.375.375,0,0,0-.039-.5l-.031-.026a.342.342,0,0,1-.032-.02",
    transform: "translate(-107.792 -230.396)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17884",
    "data-name": "Path 17884",
    d: "M108.629,235.483a.27.27,0,0,0,.029.024.371.371,0,0,0,.52-.068l3.409-4.445a.376.376,0,0,0-.041-.495c-.009-.007-.019-.017-.029-.024a.239.239,0,0,0-.032-.022.361.361,0,0,0-.192-.053.365.365,0,0,0-.294.145l-2.937,3.828v0l-.249-3.384-.1.02a.66.66,0,0,0-.528.687l.251,3.39a.578.578,0,0,0,.2.4Zm.254.1h0a.369.369,0,0,1-.227-.077.284.284,0,0,1-.029-.026h0a.6.6,0,0,1-.2-.4l-.251-3.391a.665.665,0,0,1,.529-.69l.108-.02v0l.249,3.383L112,230.544a.37.37,0,0,1,.49-.093l.032.022.031.026a.378.378,0,0,1,.039.5l-3.407,4.445a.366.366,0,0,1-.3.146",
    transform: "translate(-107.792 -230.396)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17885",
    "data-name": "Path 17885",
    d: "M110.618,250.039a3.552,3.552,0,0,1,3.763-3.378h1.434a2.933,2.933,0,0,0,2.493-1.088l5.856-7.845c1.856-2.221,2.853-3.691,6.027-3.691h.727a3.552,3.552,0,0,1,3.763,3.378c0,.522,0,.916-.007,1.217h2.874v-1.951a6.232,6.232,0,0,0-6.13-5.516h-2.46a7.1,7.1,0,0,0-5.925,3.352l-6.107,7.959c-.586.763-1.133,1.382-2.054,1.382h-.994a6.23,6.23,0,0,0-6.128,5.509s0,.981,0,1.889h2.867v-1.217",
    transform: "translate(-107.75 -230.472)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17886",
    "data-name": "Path 17886",
    d: "M127.293,242.682l-6.525,8.4a6.6,6.6,0,0,1-5.423,2.7h-7.593a2.8,2.8,0,0,0,2.811,2.867h6.31a6.829,6.829,0,0,0,5.262-2.733l6.512-8.509c.9-1.244,1.339-1.383,3.079-1.383h3.108a2.707,2.707,0,0,0,2.716-2.867h-6.967c-1.8,0-2.325.254-3.29,1.523",
    transform: "translate(-107.75 -231.458)",
    fill: "#007dc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9232",
    "data-name": "Group 9232",
    transform: "translate(216.241 237.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17887",
    "data-name": "Path 17887",
    d: "M256.735,282.472l-13-12.988a.663.663,0,0,0-.932,0l-13.1,12.891a2.167,2.167,0,0,1,.012-3.081l11.538-11.356a2.87,2.87,0,0,1,4.037.015l11.453,11.442a2.167,2.167,0,0,1-.012,3.08",
    transform: "translate(-229.069 -259.151)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17888",
    "data-name": "Path 17888",
    d: "M251.327,279.33l-.044,11.883a1.091,1.091,0,0,1-1.093,1.085l-13.069-.049a1.09,1.09,0,0,1-1.085-1.093l.044-11.855-2.186,2.153-.036,9.694a3.27,3.27,0,0,0,3.255,3.279l13.069.049a3.271,3.271,0,0,0,3.279-3.255l.036-9.724Z",
    transform: "translate(-229.542 -260.354)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17889",
    "data-name": "Path 17889",
    d: "M237.929,261.453a7.755,7.755,0,0,1,12.48-.044",
    transform: "translate(-229.943 -258.28)",
    fill: "none",
    stroke: "#007dc5",
    strokeMiterlimit: 10,
    strokeWidth: 2.029
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17890",
    "data-name": "Path 17890",
    d: "M240.9,264.758a4.417,4.417,0,0,1,7.109-.025",
    transform: "translate(-230.236 -258.741)",
    fill: "none",
    stroke: "#007dc5",
    strokeMiterlimit: 10,
    strokeWidth: 2.029
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17891",
    "data-name": "Path 17891",
    d: "M260.774,65.629a8.206,8.206,0,0,1-3.768,6.908H231.884a8.217,8.217,0,0,1,2.446-16.062c.156,0,.312,0,.466.013a8.219,8.219,0,0,1,16.133,1.086,8.223,8.223,0,0,1,9.844,8.055Z",
    transform: "translate(-12.537)",
    fill: "#fff",
    stroke: "#007dc5",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9234",
    "data-name": "Group 9234",
    transform: "translate(304.757 202.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9233",
    "data-name": "Group 9233",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17892",
    "data-name": "Path 17892",
    d: "M332.694,233.084h0l-.076.084a.739.739,0,0,0,0,.972l.083.093,2.1,2.36v-1.156l-1.584-1.782,1.586-1.777,0,0V230.72l-2.106,2.361Z",
    transform: "translate(-327.783 -220.66)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17893",
    "data-name": "Path 17893",
    d: "M350.337,233.186l-.076-.085-2.1-2.368v1.156l1.583,1.78-1.585,1.778,0,0V236.6l2.1-2.355.083-.095a.736.736,0,0,0,0-.969",
    transform: "translate(-329.334 -220.661)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17894",
    "data-name": "Path 17894",
    d: "M353.283,222.412l-.047-.437a2.708,2.708,0,0,0-2.632-2.393l-.435,0v0l-19.751-.019v0l-.435,0a2.709,2.709,0,0,0-2.638,2.388l-.048.437Z",
    transform: "translate(-327.276 -219.559)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17895",
    "data-name": "Path 17895",
    d: "M336.7,224.394l-.018,18.517,0,0,0,.281-6.574-.006.018-18.8-2.828,0-.018,18.517,0,0v.281h0l0,.026v.129a2.7,2.7,0,0,0,1.083,2.115c.039.029.078.056.118.083.019.012.036.026.053.036a2.631,2.631,0,0,0,1.422.44l.06,0,.088.01v-.01l.288,0v0l9.023.009.091.01v-.01l0-2.828.018-18.8Z",
    transform: "translate(-327.274 -220.035)",
    fill: "#007dc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17896",
    "data-name": "Path 17896",
    d: "M354.764,243.207l0-.281,0,0,.018-18.517-2.828,0-.018,18.8-6.574-.006,0-.281,0,0,.018-18.517-2.828,0-.018,18.8,0,2.828v.01l.092-.01,9.023.009,0,0h.288v.009l.09-.01h.059a2.654,2.654,0,0,0,1.423-.437c.02-.013.039-.027.06-.041.037-.026.074-.05.11-.078a2.7,2.7,0,0,0,1.088-2.114l0-.129,0-.026Z",
    transform: "translate(-328.779 -220.036)",
    fill: "#007dc5"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(312.627 151.938)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(257.965 189.647)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 10.431,
    cy: 10.431,
    r: 10.431,
    transform: "translate(181.951 82.387)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(253.158 103.865)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(361.921 140.52)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(168.731 136.915)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(170.835 223.411)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 4.8,
    cy: 4.8,
    r: 4.8,
    transform: "translate(99.027 179.245)",
    fill: "#badaf3",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17897",
    "data-name": "Path 17897",
    d: "M245.308,86.4v45.479",
    transform: "translate(-14.431 -3.562)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 41.462,
    transform: "translate(229.676 184.987)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 35.754,
    x2: 73.009,
    transform: "translate(255.214 110.776)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 63.268,
    y2: 39.467,
    transform: "translate(144.348 170.758)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y1: 17.427,
    x2: 40.261,
    transform: "translate(137.738 95.453)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y1: 24.336,
    x2: 43.565,
    transform: "translate(249.506 225.548)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 11.417,
    y2: 27.641,
    transform: "translate(328.524 120.09)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 13.821,
    transform: "translate(320.412 177.476)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 56.484,
    y2: 2.704,
    transform: "translate(251.008 159.148)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 8.713,
    x2: 21.632,
    transform: "translate(336.937 148.632)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 28.843,
    y2: 48.373,
    transform: "translate(334.834 152.238)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 6.309,
    y1: 17.426,
    transform: "translate(358.269 118.588)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 70.605,
    y1: 20.43,
    transform: "translate(252.811 69.615)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 57.085,
    y2: 13.52,
    transform: "translate(267.232 95.453)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 12.919,
    y2: 23.134,
    transform: "translate(240.192 115.583)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 11.718,
    y1: 21.332,
    transform: "translate(241.393 78.027)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x1: 8.412,
    y2: 5.408,
    transform: "translate(201.734 77.426)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 18.327,
    y2: 32.449,
    transform: "translate(199.631 104.466)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 9.315,
    y2: 29.143,
    transform: "translate(175.895 105.067)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 24.336,
    y2: 2.704,
    transform: "translate(140.442 136.615)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 25.839,
    y2: 8.712,
    transform: "translate(181.904 143.525)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 22.534,
    y1: 15.924,
    transform: "translate(185.21 235.162)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x1: 7.511,
    y2: 22.834,
    transform: "translate(103.187 150.736)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y1: 34.551,
    x2: 54.381,
    transform: "translate(113.402 147.431)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y1: 21.332,
    x2: 89.234,
    transform: "translate(114.003 162.754)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 21.933,
    y2: 7.211,
    transform: "translate(144.048 218.036)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 40.78,
    x2: 33.902,
    transform: "translate(182.506 179.36)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 13.821,
    y2: 15.323,
    transform: "translate(245.299 173.27)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 17.126,
    y2: 9.014,
    transform: "translate(281.353 205.117)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17898",
    "data-name": "Path 17898",
    d: "M249.225,210.185l8.475-3.249c7.176-2.751,10.872-11.1,8.257-18.649l-13-37.528c-2.615-7.549-10.551-11.438-17.727-8.687l-8.475,3.249c-7.176,2.751-10.872,11.1-8.257,18.649l13,37.528C234.114,209.047,242.05,212.935,249.225,210.185Z",
    transform: "translate(-11.703 -8.967)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 11.267,
    y2: 13.52,
    transform: "translate(107.693 192.198)",
    fill: "none",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9241",
    "data-name": "Group 9241",
    transform: "translate(184.087 127.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17899",
    "data-name": "Path 17899",
    d: "M258.2,208.356a5.385,5.385,0,0,1-.133.755h0c-.356,1.539-1.642,5.245-6.194,9.481-5.993,5.576-10.487,8.886-13.151,11.215,0,0,.125-1.267-5.993,8.721,0,0-29.715,14.877-39.329-17.585,0,0,12.194-3.912,12.61-8.739s-2.5-22.911-2.581-24.658,1.416-11.571,1.332-15.066a47.817,47.817,0,0,1,1.664-10.987c.333-.665-.25-7.158.417-7.824,0,0,.558-2.078,3.242-1.458l6.681,19.7a34.274,34.274,0,0,0,.147,5.725,51.84,51.84,0,0,0,2.247,5.825c.127.19.592.573,1.612.269a5.081,5.081,0,0,0,1.135-.518.635.635,0,0,1,.275-.087c.918-.065,2.114,1.9,3.092,3.922,1.014,2.093,1.8,4.24,1.8,4.24l5.845,14.757,2.727,6.885Z",
    transform: "translate(-193.397 -137.481)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17900",
    "data-name": "Path 17900",
    d: "M256.977,156.756s3.163-2.5,5.91.333.832,4.5.832,4.5-1.914,2.581-4.162,2.746-4.328-2.331-4.661-4.079S256.977,156.756,256.977,156.756Z",
    transform: "translate(-199.461 -137.84)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17901",
    "data-name": "Path 17901",
    d: "M256.977,156.756s3.163-2.5,5.91.333.832,4.5.832,4.5-1.914,2.581-4.162,2.746-4.328-2.331-4.661-4.079S256.977,156.756,256.977,156.756Z",
    transform: "translate(-199.461 -137.84)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9235",
    "data-name": "Group 9235",
    transform: "translate(16.311 14.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17902",
    "data-name": "Path 17902",
    d: "M218.174,171.721l-6.681-19.7c.056.014.113.027.169.042a4.229,4.229,0,0,1,1.974,1.517l4.525,13.348C218.212,168.489,218.194,170.166,218.174,171.721Z",
    transform: "translate(-211.493 -152.017)",
    fill: "#dceaf8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9236",
    "data-name": "Group 9236",
    transform: "translate(15.828 0.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17903",
    "data-name": "Path 17903",
    d: "M268.442,202.229a2.019,2.019,0,0,1-1.26,2.554l-5.853,1.985-3.814,1.293L237.045,215l-2.631.892c-.4.135-1.015-.613-1.371-1.661l-10.268-30.286c-.356-1.049-.937-2.765-1.293-3.814l-2.714-8.006a14.177,14.177,0,0,1-.623-3.92s.014-1.22-.036-2.783c-.017-.622-.048-1.225-.09-1.8a25.083,25.083,0,0,0-4.435-11.552,4.229,4.229,0,0,0-1.974-1.517l-.058-.015a4.579,4.579,0,0,1-.5-1.169c-.213-.627-.061-1.252.337-1.386l2.631-.892,21.159-7.175,3.814-1.293,5.165-1.751a2.019,2.019,0,0,1,2.554,1.26Z",
    transform: "translate(-210.957 -136.77)",
    fill: "#75bee9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9237",
    "data-name": "Group 9237",
    transform: "translate(18.454 16.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17904",
    "data-name": "Path 17904",
    d: "M218.4,167.1l-4.525-13.348a25.083,25.083,0,0,1,4.435,11.552C218.349,165.87,218.379,166.473,218.4,167.1Z",
    transform: "translate(-213.871 -153.747)",
    fill: "#dceaf8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9238",
    "data-name": "Group 9238",
    transform: "translate(16.984 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17905",
    "data-name": "Path 17905",
    d: "M270.017,201.65c.356,1.049.321,2.017-.078,2.152l-2.631.891-5.853,1.985-1.907.647-1.907.647-20.471,6.939a2.02,2.02,0,0,1-2.554-1.26l-10.307-30.4c-.356-1.049-.937-2.765-1.293-3.814l-4.135-12.2a14.14,14.14,0,0,1-.694-3.131l-.042-.571c-.256-3.4-3.516-9.76-3.516-9.76a33.308,33.308,0,0,1-1.566-3.7l-.176-.519-.647-1.907,1.907-.647,21.159-7.174,3.814-1.293,5.165-1.751,2.631-.891c.4-.135,1.015.613,1.371,1.661Z",
    transform: "translate(-212.24 -135.882)",
    fill: "#007dc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9239",
    "data-name": "Group 9239",
    transform: "translate(51.355 65.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17906",
    "data-name": "Path 17906",
    d: "M259.713,211.789a.972.972,0,0,1-.607,1.229l-6.516,2.209a.972.972,0,0,1-1.229-.607l-.938-2.767a.971.971,0,0,1,.607-1.229l6.516-2.209a.971.971,0,0,1,1.229.607Z",
    transform: "translate(-250.372 -208.364)",
    fill: "none",
    stroke: "#75bee9",
    strokeMiterlimit: 10,
    strokeWidth: 0.379
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4029",
    "data-name": "Rectangle 4029",
    width: 33.759,
    height: 51.948,
    transform: "translate(21.396 19.55) rotate(-18.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9240",
    "data-name": "Group 9240",
    transform: "translate(32.717 9.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17907",
    "data-name": "Path 17907",
    d: "M237.059,146.882a.1.1,0,0,1-.063.128l-6.919,2.345a.1.1,0,0,1-.128-.063l-.249-.735a.1.1,0,0,1,.063-.128l6.919-2.345a.1.1,0,0,1,.128.063Z",
    transform: "translate(-229.695 -146.079)",
    fill: "none",
    stroke: "#75bee9",
    strokeMiterlimit: 10,
    strokeWidth: 0.394
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17908",
    "data-name": "Path 17908",
    d: "M267.042,167.252s-2.934-.562-3.5,2.934,1.516,7.069,2.35,7.5a11.353,11.353,0,0,0,1.646.679,4.505,4.505,0,0,0-1.124,4.5c.687,3,1.873,4.245,2.622,4.619s.062.25.062.25l2.017,5.362,3.391,10s4.268-2.692,4.206-5.5.562-6.117-3-7.491-4.12,2-4.12,2-.25-1.623-.625-1.748c0,0,3.371-3.433,3.933-4.869a6.4,6.4,0,0,0-.562-5.432c-1.124-2.06-4.182-2.622-4.182-2.622s2.5-1.5,2.435-3.433S271.974,167.564,267.042,167.252Z",
    transform: "translate(-200.308 -138.973)",
    fill: "#dceaf8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4030",
    "data-name": "Rectangle 4030",
    width: 33.925,
    height: 52.203,
    transform: "translate(21.476 19.501) rotate(-18.614)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9244",
    "data-name": "Group 9244",
    transform: "translate(222.543 152.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9242",
    "data-name": "Group 9242"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 4.65,
    cy: 4.893,
    rx: 4.65,
    ry: 4.893,
    fill: "#badaf3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 4.032,
    cy: 4.241,
    rx: 4.032,
    ry: 4.241,
    transform: "translate(0.618 0.652)",
    fill: "#005e9e",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17909",
    "data-name": "Path 17909",
    d: "M240.468,167.374a.246.246,0,0,1,.4-.152l1.041.888,1.043.89a.253.253,0,0,1-.078.424l-1.3.5-1.3.5a.238.238,0,0,1-.319-.27l.254-1.387Z",
    transform: "translate(-236.445 -163.907)",
    fill: "#75bee9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(6.384 19.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 4.208,
    cy: 4.427,
    rx: 4.208,
    ry: 4.427,
    fill: "#badaf3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 3.648,
    cy: 3.837,
    rx: 3.648,
    ry: 3.837,
    transform: "translate(0.56 0.589)",
    fill: "#005e9e",
    stroke: "#badaf3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17910",
    "data-name": "Path 17910",
    d: "M248.26,190.788a.246.246,0,0,1-.4.152l-1.041-.888-1.043-.89a.253.253,0,0,1,.078-.424l1.3-.5,1.3-.5a.238.238,0,0,1,.319.27l-.254,1.387Z",
    transform: "translate(-14.469 -13.559)",
    fill: "#75bee9"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialCall);
export default __webpack_public_path__ + "static/media/special-call.58d665ad.svg";
export { ForwardRef as ReactComponent };